import type { ReactNode } from 'react';

export function Card({ title, children, className = '' }: { title?: string; children: ReactNode; className?: string }) {
  return (
    <div
      className={`rounded-xl border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-900 ${className}`}
    >
      {title && <h3 className="mb-4 text-sm font-medium text-slate-500 dark:text-slate-400">{title}</h3>}
      {children}
    </div>
  );
}
